import type { AnchorHTMLAttributes, ReactNode, Ref } from 'react'
import styles from './side-nav.module.css'
import { cx } from './cx'

/**
 * Чёрная боковая панель десктопа: та же пилюля навигации, только вертикальная.
 * Сверху бренд, посередине разделы, снизу профиль.
 */
export function SideNav({
  brand,
  footer,
  children,
  label = 'Разделы',
}: {
  brand: ReactNode
  footer?: ReactNode
  children: ReactNode
  label?: string
}) {
  return (
    <aside className={styles.panel}>
      <div className={styles.brand}>{brand}</div>
      <nav aria-label={label} className={styles.items}>
        {children}
      </nav>
      {footer !== undefined && <div className={styles.footer}>{footer}</div>}
    </aside>
  )
}

export type SideNavItemProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  ref?: Ref<HTMLAnchorElement>
  icon?: ReactNode
}

/** Пункт боковой панели: оборачивается `createLink` роутера, активный подсвечен и с оранжевой точкой. */
export function SideNavItem({ className, icon, children, ...rest }: SideNavItemProps) {
  return (
    <a className={cx(styles.item, className)} {...rest}>
      {icon !== undefined && <span className={styles.icon}>{icon}</span>}
      <span className={styles.text}>{children}</span>
    </a>
  )
}
